module.exports = __webpack_public_path__ + "img/ic_flag_spain.f21d5082.svg";